var _polyline, _polygon, _polygon2, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClase42(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normal",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "708.251px",
    height: "711.986px",
    viewBox: "0 0 708.251 711.986",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#EF4136",
    points: "44.183,358.086 0,358.086 353.899,711.986 707.805,358.086 664.778,358.086 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "665.225,357.989 708.251,357.989 354.346,4.089 0.446,357.989 44.629,357.989 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.307,252.592 290.366,266.801 306.171,277.754 326.138,285.061 340.748,286.358 356.495,286.846  340.748,283.923 329.435,277.588 318.346,265.58 309.903,246.911 317.372,252.43 324.767,254.416 339.456,255.977 333.365,247.006  327.76,242.041 326.138,232.462 325.97,215.027 329.059,223.858 333.767,230.189 340.261,234.572 348.215,237.981 346.325,225.209  346.169,216.182 352.727,203.714 358.165,186.747 356.859,177.176 364.908,185.441 372.522,196.971 375.948,213.271  374.112,236.399 386.359,229.382 395.456,223.046 398.654,214.496 398.845,231.778 394.969,243.664 388.476,252.105  381.495,256.489 391.56,256.327 401.462,254.542 410.552,248.695 400.812,267.041 388.638,278.565 379.634,283.426 373.717,287.084  387.015,287.008 397.73,284.311 410.475,278.08 422.511,269.727 431.981,253.404 438.312,233.273 439.448,205.027 437.339,215.092  429.385,221.262 416.235,224.67 424.493,212.237 428.572,202.918 431.981,187.658 430.196,176.942 425.812,161.521 417.858,174.184  411.794,183.26 401.488,187.946 407.469,172.723 409.286,154.986 405.846,139.93 399.011,123.399 397.104,143.021 391.177,156.693  386.852,163.955 381.007,165.254 382.964,152.594 380.846,141.065 370.456,118.339 360.228,95.611 354.222,74.995 349.839,86.195  347.881,96.404 347.802,119.598 347.506,137.583 345.131,148.695 339.774,160.871 334.235,149.546 331.842,136.713 328.362,127.576  321.917,122.885 312.339,118.664 317.047,132.139 314.774,142.689 312.988,153.729 313.151,169.475 317.047,180.189  308.931,175.321 300.813,165.905 290.292,150.199 292.534,168.827 290.586,180.839 292.372,196.911 296.591,205.908  304.222,218.827 290.423,216.879 281.59,209.807 276.806,203.063 268.183,196.262 270.456,208.436 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 282.668,
    y: 299.348,
    width: 142.579,
    height: 17.498
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.479,672.968l312.594-312.587l-2.295-2.294L354.479,47.793L44.183,358.086l-2.292,2.293L354.479,672.968z  M354.479,61.563c6.376,6.375,268.598,268.593,296.527,296.524c1.229,1.228,2.014,2.015,2.295,2.294 c-6.655,6.654-292.166,292.161-298.822,298.814c-6.655-6.653-292.164-292.16-298.818-298.816c0.281-0.281,1.066-1.066,2.294-2.293 C85.875,330.167,348.104,67.937,354.479,61.563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.444,626.429h11.67V613.99h7.859v-10.386h-7.859v-39.108h-10.125l-27.265,39.15v10.344h25.72V626.429z M342.998,603.604 l14.447-20.958v20.958H342.998z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.492,
    y: 328.357,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -227.9627 114.4167)",
    width: 45.286,
    height: 8.065
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.33,
    y: 278.52,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -178.1293 135.066)",
    width: 45.286,
    height: 8.064
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101.872,
    y: 227.979,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -127.5869 155.9995)",
    width: 45.285,
    height: 8.064
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 152.412,
    y: 177.436,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -77.0446 176.9414)",
    width: 45.287,
    height: 8.064
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 202.955,
    y: 126.895,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -26.5035 197.8693)",
    width: 45.285,
    height: 8.065
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 252.665,
    y: 77.186,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 23.2061 218.46)",
    width: 45.285,
    height: 8.064
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 370.108,
    y: -3.781,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 96.2885 270.1293)",
    width: 8.064,
    height: 45.286
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 420.409,
    y: 46.52,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 75.4532 320.4422)",
    width: 8.064,
    height: 45.286
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 470.71,
    y: 96.821,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 54.5752 370.6839)",
    width: 8.065,
    height: 45.286
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 521.01,
    y: 147.122,
    transform: "matrix(0.707 -0.7073 0.7073 0.707 33.7935 421.0892)",
    width: 8.064,
    height: 45.286
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 571.312,
    y: 197.422,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 12.9476 471.3815)",
    width: 8.064,
    height: 45.287
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 621.612,
    y: 247.723,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -7.8878 521.6941)",
    width: 8.064,
    height: 45.286
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 671.913,
    y: 298.024,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -28.7231 572.0071)",
    width: 8.064,
    height: 45.286
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 303.29,
    y: 26.561,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 73.8311 239.4296)",
    width: 45.285,
    height: 8.064
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClase42);
export default __webpack_public_path__ + "static/media/clase4-2.cd7386734c98061a029e7d53f5229607.svg";
export { ForwardRef as ReactComponent };